import {InitThumbnails, showThumbnails} from './thumbnails';

let postIndex = 9;
const FEED_INCREMENT = 9;

export function InitInstagramFeed() {
	let request = new XMLHttpRequest();
	const feedContainer = document.querySelector('.instagram_feed .feed-container');

	if (feedContainer === null)
		return;

	request.open('GET', '/instagram_feed');
	request.onload = () => {
		if (request.status !== 200) {
			// Couldn't be loaded
		} else {
			feedContainer.innerHTML = request.responseText; // TODO security flaw because of innerHTML

			const postThumbnails = feedContainer.querySelectorAll('.instagram-container > .thumbnail');

			if (postThumbnails.length === 0)
				return;

			InitThumbnails(postThumbnails);

			InitLoadMore(postThumbnails);
		}
	};

	request.send();
}

function InitLoadMore(newsThumbnails) {
	const buttonLoadMore = document.querySelector('.instagram_feed .button-primary');

	if (buttonLoadMore === null)
		return;

	if (postIndex > newsThumbnails.length)
		buttonLoadMore.style.display = 'none';

	buttonLoadMore.addEventListener('click', () => {
		showThumbnails(newsThumbnails, postIndex, FEED_INCREMENT);
		postIndex += FEED_INCREMENT;

		if (postIndex > newsThumbnails.length)
			buttonLoadMore.style.display = 'none';
	});
}
